(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const megamenuDropdownEle = this.header.querySelectorAll('[id^="Details-HeaderMenu-"]');

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        
        /*for closing menu dropwon if open*/
        if(megamenuDropdownEle.length){
          megamenuDropdownEle.forEach(e => {
            e.removeAttribute('open');
            e.querySelector('summary').setAttribute('aria-expanded','false');
          });
        }
        /*END*/
        
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juicer-compare"]) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function(){
    slideChangeMain();
    slideButtonTriggerEvent();
  });

  function slideChangeMain(){
    const mainSectionEle = document.querySelector('.juicer-compare');
      
    const smallTriggerBtn = document.querySelectorAll('.juicer-compare [data-small-slide-trigger]');
    const largeTriggerBtn = document.querySelectorAll('.juicer-compare [data-large-slide-trigger]');
    
    const smallHoverEle = document.querySelector('.juicer-compare [data-small-slide-hover]');
    const largeHoverEle = document.querySelector('.juicer-compare [data-large-slide-hover]');

    //apply click event for small juicer slide
    if(smallTriggerBtn.length){
      smallTriggerBtn.forEach(btn => {
        btn.addEventListener('click', function(e){
          e.preventDefault();
          e.currentTarget.classList.add('active');
          document.querySelector('.juicer-compare [data-mobile-btn] [data-large-slide-trigger]').classList.remove('active');
          slideChangeEvent(e);
        });
      });
    }
    
    //apply hover event for small juicer slide
    if(window.screen.width > 989 && smallHoverEle){
      smallHoverEle.addEventListener('mouseenter', function(e){
        e.preventDefault();
        slideChangeEvent(e);
      });
    }

    //apply click event for large juicer slide
    if(largeTriggerBtn.length){
      largeTriggerBtn.forEach(btn => {
        btn.addEventListener('click', function(e){
          e.preventDefault();
          e.currentTarget.classList.add('active');
          document.querySelector('.juicer-compare [data-mobile-btn] [data-small-slide-trigger]').classList.remove('active');
          slideChangeEvent(e);
        });
      });
    }

    //apply hover event for large juicer slide
    if(window.screen.width > 989 && largeHoverEle){
      largeHoverEle.addEventListener('mouseenter', function(e){
        e.preventDefault();
        slideChangeEvent(e);
      });
    }


    //check if main section is in screen viewport 
    // if not in viewport we change the section to its original position
    if(window.screen.width > 989){
      window.addEventListener('scroll', () => {
        if(!isInViewport(mainSectionEle)){
          document.querySelector('.juicer-compare-main').classList.remove('juicer-compare-start','large-active','small-active');
          document.querySelector('.juicer-compare').style.removeProperty("height");
        }  
      });
    }
    
  }

  function slideChangeEvent(targetEle){
    const mainSectionEle = document.querySelector('.juicer-compare-main');
    
    if(mainSectionEle){
      //add class to main parent for smooth transitioning
      if(targetEle.type == 'mouseenter'){
        mainSectionEle.classList.add('juicer-compare-start');
      }
        
      if(targetEle.type == 'click' && targetEle.currentTarget.hasAttribute('data-small-slide-trigger') || 
         targetEle.type == 'mouseenter' && targetEle.currentTarget.closest('[data-small-slide-hover]')){
        mainSectionEle.classList.remove('large-active','mob-large-active');
        mainSectionEle.classList.add('small-active','mob-small-active');
        document.querySelector('.juicer-compare [data-mobile-btn] [data-small-slide-trigger]').classList.add('active');
        document.querySelector('.juicer-compare [data-cation-small]').classList.remove('hidden');
        document.querySelector('.juicer-compare [data-cation-large]').classList.add('hidden');
        
        //add dynamic height for the main section
        if(window.screen.width > 989){
          const getSmallSectionPopupHeight = document.querySelector('.juicer-compare .juicer-compare-small').scrollHeight;
          document.querySelector('.juicer-compare').style.height = `${getSmallSectionPopupHeight+60}px`;
          setTimeout(() => {
            window.scrollTo({top: mainSectionEle.offsetTop-50, behavior: 'smooth'})
          },400);
        }
      }
      if(targetEle.type == 'click' && targetEle.currentTarget.hasAttribute('data-large-slide-trigger') || 
         targetEle.type == 'mouseenter' && targetEle.currentTarget.closest('[data-large-slide-hover]')){
        mainSectionEle.classList.remove('small-active','mob-small-active');
        mainSectionEle.classList.add('large-active','mob-large-active');
        document.querySelector('.juicer-compare [data-mobile-btn] [data-large-slide-trigger]').classList.add('active');
        document.querySelector('.juicer-compare [data-cation-small]').classList.add('hidden');
        document.querySelector('.juicer-compare [data-cation-large]').classList.remove('hidden');
        
        //add dynamic height for the main section
        if(window.screen.width > 989){
          const getLargeSectionPopupHeight = document.querySelector('.juicer-compare .juicer-compare-large').scrollHeight;
          document.querySelector('.juicer-compare').style.height = `${getLargeSectionPopupHeight+60}px`;
          setTimeout(() => {
            window.scrollTo({top: mainSectionEle.offsetTop-50, behavior: 'smooth'})
          },400);
        }
      }
    }
  }

  function slideButtonTriggerEvent(){
    
    const buyNowSmallBtn = document.querySelectorAll('.juicer-compare [data-small-btn-trigger]');
    const buyNowlargeBtn = document.querySelectorAll('.juicer-compare [data-large-btn-trigger]');

    //click event for buy the samll  btn
    if(buyNowSmallBtn.length){
      buyNowSmallBtn.forEach(btn => {
        btn.addEventListener('click', function(e){
          e.preventDefault();
          const featuredProductSizeSmall = document.querySelector('.juicer-featured-product .featured-product:not(.hidden) a[data-size="small"]');
          const featuredProductEle = document.querySelector('.juicer-featured-product').scrollHeight - 10;
          if(featuredProductSizeSmall){
            featuredProductSizeSmall.click();
            setTimeout(() => window.scrollTo({top: featuredProductEle, behavior: 'smooth'}));
          }
        });
      });
    }

    //click event for buy the large  btn
    if(buyNowlargeBtn.length){
      buyNowlargeBtn.forEach(btn => {
        btn.addEventListener('click', function(e){
          e.preventDefault();
          const featuredProductSizeLarge = document.querySelector('.juicer-featured-product .featured-product:not(.hidden) a[data-size="large"]');
          const featuredProductEle = document.querySelector('.juicer-featured-product').scrollHeight - 10;
          if(featuredProductSizeLarge){
            featuredProductSizeLarge.click();
            setTimeout(() => window.scrollTo({top: featuredProductEle, behavior: 'smooth'}));
          }
        });
      });
    }
    
  }

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    const elementHeight = el.offsetHeight;
    const elementWidth = el.offsetWidth;
  
    return (
      rect.top >= -elementHeight && 
      rect.left >= -elementWidth &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) + elementWidth &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + elementHeight
    );
  }

  function imgMangificForMobile(){
    const magnifyImages = document.querySelectorAll('.juicer-compare [data-img-magnify]');
    const magnifyImagesElement = document.querySelector(".juicer-compare [data-img-magnify-container] img");

    if(!magnifyImages.length && !magnifyImagesElement) return;
    
    magnifyImages.forEach(function(image) {
      image.addEventListener("click", function(e) {
        e.preventDefault();
        const src = this.querySelector('img').getAttribute("src");
        magnifyImagesElement.setAttribute("src", src);
        document.body.classList.add('lightbox-img-open');
      });
    });

    //outside click close model popup
    document.body.addEventListener("click", function(e) {
      if(e.target.hasAttribute('data-img-magnify-container')){
        document.body.classList.remove('lightbox-img-open');
      }
    });

  }

  
  // This will only render in the theme editor
  if (Shopify.designMode) {
     document.addEventListener("DOMContentLoaded", function() {
      document.addEventListener('shopify:section:load', function(){
       const sectionContainer = event.target.closest('.juicer-compare') || null;
        if(sectionContainer){
          slideChangeMain();
          slideButtonTriggerEvent();
        }
      });
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juicer-featured-product"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function(){
    handleColorSwatchChange();
    handleSizeSwatchChange();
    handleVariantAdd();
    handleSizeSlideout();
    handleAccordion();
  });
  
  function handleColorSwatchChange(){
    const colorSwatch = document.querySelectorAll('.juicer-featured-product [data-color]');
    if(!colorSwatch.length) return;
    colorSwatch.forEach((btn) => {
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if(e.currentTarget.classList.contains('active')) return;
        let currentColor = e.currentTarget.dataset.color;
        let currentSizeSelected = e.currentTarget.closest('.product__info-container').querySelector('.size-swatch-wrap .size-block.active').dataset.size;
        const totalColorSlide = document.querySelectorAll(`.juicer-featured-product [data-variant-${currentSizeSelected}]`);
        totalColorSlide.forEach(e => e.classList.add('hidden'));
        document.querySelectorAll(`.juicer-featured-product [data-variant-${currentSizeSelected}][data-color-variant="${currentColor}"] [data-color]`).forEach(e => e.classList.remove('active'));
        document.querySelector(`.juicer-featured-product [data-variant-${currentSizeSelected}][data-color-variant="${currentColor}"] [data-color="${currentColor}"]`).classList.add('active');
        document.querySelector(`.juicer-featured-product [data-variant-${currentSizeSelected}][data-color-variant="${currentColor}"]`).classList.remove('hidden');
      });
    });
  }

  function handleSizeSwatchChange(){
    const sizeSwatch = document.querySelectorAll('.juicer-featured-product [data-size]');
    if(!sizeSwatch.length) return;
    sizeSwatch.forEach((btn) => {
      btn.addEventListener('click', function(e){
        // console.log("click");
        e.preventDefault();
        if(e.currentTarget.classList.contains('active')) return;

        let currentColor = e.currentTarget.closest('.product__info-container').querySelector('.color-swatch-wrap .color-block.active').dataset.color;
        let currentSizeSelected = e.currentTarget.dataset.size;
        
        document.querySelectorAll(`.juicer-featured-product [data-color-variant]`).forEach(e => e.classList.add('hidden'));
        const currentColorEle = document.querySelector(`.juicer-featured-product [data-variant-${currentSizeSelected}][data-color-variant="${currentColor}"]`);
        if(currentColorEle){
          currentColorEle.querySelectorAll(`[data-color]`).forEach(e => e.classList.remove('active'));
          currentColorEle.querySelector(`[data-color="${currentColor}"]`).classList.add('active');
          currentColorEle.classList.remove('hidden');
        }else{
          document.querySelector(`.juicer-featured-product [data-variant-${currentSizeSelected}]`).classList.remove('hidden');
        }

        var dimAccordions = document.querySelectorAll(`.faq-dim-accordion[data-size]`);
        if(dimAccordions.length){
          dimAccordions.forEach((accordion) => {
            // console.log("accordion",accordion.dataset.size);
            // console.log("currentSizeSelected",currentSizeSelected);
            if(currentSizeSelected == accordion.dataset.size){
              accordion.classList.remove("hidden");
            }else{
              accordion.classList.add("hidden");
            }
          });
        }
        
      });
    });
  }

  function handleVariantAdd(){
    const addToCartBtn = document.querySelectorAll('.juicer-featured-product [data-add-cart]');
    if(!addToCartBtn.length) return;
    addToCartBtn.forEach(btn => {
      btn.addEventListener('click', function(e){
        e.preventDefault();

        // console.log("productJuicerJson",productJuicerJson);
        if(!productJuicerJson) return;
        
        let selectedSize = e.currentTarget.closest('.product__info-container').querySelector('.size-swatch-wrap .size-block.active').dataset.size;
        let selectedColor = e.currentTarget.closest('.product__info-container').querySelector('.color-swatch-wrap .color-block.active').dataset.color;
        let slectedProId, qty = 1;
        if(selectedSize == 'small'){
          slectedProId = productJuicerJson.product_small[selectedColor];
          qty = productJuicerJson.product_small[`${selectedColor}-qty`];
        }else{
          slectedProId = productJuicerJson.product_large[selectedColor];
          qty = productJuicerJson.product_large[`${selectedColor}-qty`];
        }
        
        if(!slectedProId) return;
        
        const body = JSON.stringify({
          id: slectedProId,
          quantity: qty
        });
        fetch(`${window.routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            //for any add to cart error
          } else {
            // window.location = window.routes.cart_url;
          }
        })
        .catch((e) => {
          console.error(e);
        });
      });
    });
  }

  // handleSizeSlideout
  function handleSizeSlideout(){
    var paddingRight = window.outerWidth-document.body.clientWidth;
    // console.log("handleSizeSlideout");
    var sizeSlideout = document.querySelector("[data-size-slideout]");
    var sizes = document.querySelectorAll("[data-juicer-size-btn]");
    var sizeSlideoutClose = document.querySelectorAll("[data-size-slideout-close]");

    if(sizeSlideout){
      
      if(sizes.length){
        sizes.forEach(btn => {
          btn.addEventListener('click', function(e){
            e.preventDefault();
            sizeSlideout.classList.add("open");
            document.body.style.paddingRight = String(paddingRight + "px");
            document.body.classList.add("overflow-hidden");
          });
        });
      }
      sizeSlideoutClose.forEach(close => {
        close.addEventListener('click', function(e){
          e.preventDefault();
          sizeSlideout.classList.remove("open");
          document.body.style.removeProperty("padding-right");
          document.body.classList.remove("overflow-hidden");
        });
      });

      var dimImgBtns = document.querySelectorAll("[data-size-img-change]");
      if(dimImgBtns.length){
        dimImgBtns.forEach(btn => {
        btn.addEventListener('click', function(e){
          e.preventDefault();
          // btn.classList.remove("changed");
          if(btn.closest("[data-size-img-wrap]").classList.contains("changed")){
            btn.closest("[data-size-img-wrap]").classList.remove("changed");
          }else{
            btn.closest("[data-size-img-wrap]").classList.add("changed");
          }
        });
      });
      }

    }
    
  }

  // handleAccordion
  function handleAccordion(){

    if(document.body.clientWidth >= 750){
      var paddingRight = window.outerWidth-document.body.clientWidth;
      var accodionWraps = document.querySelectorAll("[data-juicer-accordion-wrap]");
      var accodions = document.querySelectorAll("[data-juicer-accordion]");
      var accodionCloses = document.querySelectorAll("[data-size-accordion-close]");
      
      // document.body.clientWidth
      if(accodions.length && accodionWraps.length){
        var accodionBtns = document.querySelectorAll("[data-juicer-accordion] [data-juicer-accordion-btn]");
  
        accodionBtns.forEach(btn => {
          btn.addEventListener('click', function(e){
            e.preventDefault();
            btn.closest("[data-juicer-accordion-wrap]").classList.add("active");
            btn.closest("[data-juicer-accordion]").classList.add("open");
            document.body.style.paddingRight = String(paddingRight + "px");
            document.body.classList.add("overflow-hidden");
          });
        });
  
        accodionCloses.forEach(close => {
          close.addEventListener('click', function(e){
            e.preventDefault();
            close.closest("[data-juicer-accordion-wrap]").classList.remove("active");
            if(close.closest("[data-juicer-accordion]")){
              close.closest("[data-juicer-accordion]").classList.remove("open");
            }else{
              accodions.forEach(accodion => {
                accodion.classList.remove("open");
              });
            }
            document.body.style.removeProperty("padding-right");
            document.body.classList.remove("overflow-hidden");
          });
        });
      }
    }else{
      // var accodions = document.querySelectorAll("[data-juicer-accordion]");
      // if(accodions.length){
      //   var accodionBtns = document.querySelectorAll("[data-juicer-accordion] [data-juicer-accordion-btn]");
  
      //   accodions.forEach(accodion => {
      //     accodion.querySelector("[data-juicer-accordion-btn]").addEventListener('click', function(e){
      //       e.preventDefault();
      //       e.stopPropagation();            
      //       if( !$(accodion).hasClass('active') ){
      //         $(accodion.querySelector(".faq-content")).slideDown('slow');              
      //       }else{
      //         $(accodion.querySelector(".faq-content")).slideUp('slow');
      //       }
      //       $(accodion).toggleClass('active');            
      //     });
      //   });
      // }
    }

  }

  // This will only render in the theme editor
  if (Shopify.designMode) {
     document.addEventListener("DOMContentLoaded", function() {
      document.addEventListener('shopify:section:load', function(){
       const sectionContainer = event.target.closest('.juicer-featured-product') || null;
        if(sectionContainer){
          handleColorSwatchChange();
          handleSizeSwatchChange();
          handleVariantAdd();
          handleSizeSlideout();
          handleAccordion();
        }
      });
    });
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juicer-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const megamenuDropdownEle = this.header.querySelectorAll('[id^="Details-HeaderMenu-"]');

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        
        /*for closing menu dropwon if open*/
        if(megamenuDropdownEle.length){
          megamenuDropdownEle.forEach(e => {
            e.removeAttribute('open');
            e.querySelector('summary').setAttribute('aria-expanded','false');
          });
        }
        /*END*/
        
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juicer-parts"]) return;
  try {
    
  
  document.addEventListener('DOMContentLoaded', function(){
    const btnToScroll = document.querySelector('.juicer-parts [data-btn-parts]');
    if(btnToScroll){
      btnToScroll.addEventListener('click', function(e){
        e.preventDefault();
        const featuredProductEle = document.querySelector('.juicer-featured-product')?.scrollHeight - 10;
        if(featuredProductEle){
          window.scrollTo({top: featuredProductEle, behavior: 'smooth'});
        }
      });
    }
  });


  } catch(e) { console.error(e); }
})();
      })();
